import { FactCheckOutlined as ApprovalIcon, Circle as BulletActive, ExpandMoreRounded as ExpandIcon } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

const approvalItemsConfig = [
  {
    permission: 17,
    label: 'Transaction Approval',
    to: '/approval',
    notificationKey: 'Approval of Voucher',
    notificationArrayProp: 'transactions',
    isLoadingProp: 'isTransactionsLoading',
  },
  {
    permission: 39,
    label: 'Approval of Cheque Cancellation',
    to: '/approval/cheque-cancellation',
    notificationKey: 'Approval of Cheque Cancellation',
    notificationArrayProp: 'cheque',
    isLoadingProp: 'isChequeLoading',
  },
  {
    permission: 41,
    label: 'General Journal - AP Approval',
    to: '/approval/general-journal-AP?page=1&rows=10&status=pending',
    notificationKey: 'General Journal - AP Approval',
    notificationArrayProp: 'journals',
    isLoadingProp: 'isJournalsLoading',
  },
  {
    permission: 48,
    label: 'General Journal - Accrual & Reversal Approval',
    to: '/approval/general-journal-reversal?page=1&rows=10&status=pending',
    notificationKey: 'General Journal - Accrual & Reversal Approval',
    notificationArrayProp: 'journals',
    isLoadingProp: 'isJournalsLoading',
  },
  {
    permission: 85,
    label: 'General Journal - Accrual Reversal Approval',
    to: '/approval/general-journal-accruals-and-reversals?page=1&rows=10&status=pending',
    notificationKey: 'General Journal - Accrual Reversal Approval',
    notificationArrayProp: 'journals',
    isLoadingProp: 'isJournalsLoading',
  },
  {
    permission: 49,
    label: 'General Journal - Treasury Approval - 12',
    to: '/approval/general-journal-treasury-12?page=1&rows=10&status=pending',
    notificationKey: 'General Journal - Treasury Approval - 12',
    notificationArrayProp: 'journals',
    isLoadingProp: 'isJournalsLoading',
  },
  {
    permission: 87,
    label: 'General Journal - Treasury Approval - 22',
    to: '/approval/general-journal-treasury-22?page=1&rows=10&status=pending',
    notificationKey: 'General Journal - Treasury Approval - 22',
    notificationArrayProp: 'journals',
    isLoadingProp: 'isJournalsLoading',
  },
  {
    permission: 50,
    label: 'General Journal - Cost & Budget Approval - 12',
    to: '/approval/general-journal-cost-and-budget-12?page=1&rows=10&status=pending',
    notificationKey: 'General Journal - Cost & Budget Approval - 12',
    notificationArrayProp: 'journals',
    isLoadingProp: 'isJournalsLoading',
  },
  {
    permission: 76,
    label: 'General Journal - Cost & Budget Approval - 22',
    to: '/approval/general-journal-cost-and-budget-22?page=1&rows=10&status=pending',
    notificationKey: 'General Journal - Cost & Budget Approval - 22',
    notificationArrayProp: 'journals',
    isLoadingProp: 'isJournalsLoading',
  },
  {
    permission: 77,
    label: 'General Journal - Cost & Budget Approval - 30',
    to: '/approval/general-journal-cost-and-budget-30?page=1&rows=10&status=pending',
    notificationKey: 'General Journal - Cost & Budget Approval - 30',
    notificationArrayProp: 'journals',
    isLoadingProp: 'isJournalsLoading',
  },
  {
    permission: 51,
    label: 'General Journal - Fixed Asset Approval - 12',
    to: '/approval/general-journal-fixed-asset-12?page=1&rows=10&status=pending',
    notificationKey: 'General Journal - Fixed Asset 12 Approval',
    notificationArrayProp: 'journals',
    isLoadingProp: 'isJournalsLoading',
  },
  {
    permission: 75,
    label: 'General Journal - Fixed Asset Approval - 22',
    to: '/approval/general-journal-fixed-asset-22?page=1&rows=10&status=pending',
    notificationKey: 'General Journal - Fixed Asset Approval - 22',
    notificationArrayProp: 'journals',
    isLoadingProp: 'isJournalsLoading',
  },
  {
    permission: 52,
    label: 'General Journal - Confidential Approval - 12',
    to: '/approval/general-journal-confidential-12?page=1&rows=10&status=pending',
    notificationKey: 'General Journal - Confidential Approval - 12',
    notificationArrayProp: 'journals',
    isLoadingProp: 'isJournalsLoading',
  },
  {
    permission: 98,
    label: 'General Journal - Confidential Approval - 30',
    to: '/approval/general-journal-confidential-30?page=1&rows=10&status=pending',
    notificationKey: 'General Journal - Confidential Approval - 30',
    notificationArrayProp: 'journals',
    isLoadingProp: 'isJournalsLoading',
  },
  {
    permission: 79,
    label: 'General Journal - Confidential Approval - 22',
    to: '/approval/general-journal-confidential-22?page=1&rows=10&status=pending',
    notificationKey: 'General Journal - Confidential Approval - 22',
    notificationArrayProp: 'journals',
    isLoadingProp: 'isJournalsLoading',
  },
  {
    permission: 54,
    label: 'General Journal - Sales Approval',
    to: '/approval/general-journal-sales?page=1&rows=10&status=pending',
    notificationKey: 'General Journal - Sales Approval',
    notificationArrayProp: 'journals',
    isLoadingProp: 'isJournalsLoading',
  },
  {
    permission: 55,
    label: 'General Journal - FO Approval',
    to: '/approval/general-journal-FO?page=1&rows=10&status=pending',
    notificationKey: 'General Journal - FO Approval',
    notificationArrayProp: 'journals',
    isLoadingProp: 'isJournalsLoading',
  },
  {
    permission: 56,
    label: 'General Journal - Live Approval',
    to: '/approval/general-journal-live?page=1&rows=10&status=pending',
    notificationKey: 'General Journal - Live Approval',
    notificationArrayProp: 'journals',
    isLoadingProp: 'isJournalsLoading',
  },
  {
    permission: 61,
    label: 'General Journal - AR Approval',
    to: '/approval/general-journal-AR?page=1&rows=10&status=pending',
    notificationKey: 'General Journal - AR Approval',
    notificationArrayProp: 'journals',
    isLoadingProp: 'isJournalsLoading',
  },
  {
    permission: 68,
    label: 'General Journal - AP Specialist - 12 Approval',
    to: '/approval/general-journal-ap-specialist-12?page=1&rows=10&status=pending',
    notificationKey: 'General Journal - AP Specialist - 12 Approval',
    notificationArrayProp: 'journals',
    isLoadingProp: 'isJournalsLoading',
  },
  {
    permission: 68,
    label: 'General Journal - AP Specialist Approval - 22',
    to: '/approval/general-journal-ap-specialist-22?page=1&rows=10&status=pending',
    notificationKey: 'General Journal - AP Specialist Approval - 22',
    notificationArrayProp: 'journals',
    isLoadingProp: 'isJournalsLoading',
  },
  {
    permission: 69,
    label: 'General Journal - PCF Approval',
    to: '/approval/general-journal-pcf?page=1&rows=10&status=pending',
    notificationKey: 'General Journal - PCF Approval',
    notificationArrayProp: 'journals',
    isLoadingProp: 'isJournalsLoading',
  },
  {
    permission: 100,
    label: 'General Journal - Year End Approval',
    to: '/approval/general-journal-year-end?page=1&rows=10&status=pending',
    notificationKey: 'General Journal - Year End Approval',
    notificationArrayProp: 'journals',
    isLoadingProp: 'isJournalsLoading',
  },
  {
    permission: 102,
    label: 'General Journal - Confidential Year End',
    to: '/approval/general-journal-confidential-year-end?page=1&rows=10&status=pending',
    notificationKey: 'General Journal - Confidential Year End',
    notificationArrayProp: 'journals',
    isLoadingProp: 'isJournalsLoading',
  },
];

const SidebarApprovalDropdown = ({
  activeDropdown,
  user,
  transactions,
  shouldDisplayDotNotification,
  isTransactionsLoading,
  RouterLink,
  DisplayBubbleNotification,
  cheque,
  isChequeLoading,
  journals,
  isJournalsLoading,
}) => {
  const color = useSelector((state) => state.theme);
  const isActiveDropdown = Boolean(activeDropdown?.match(/approval/gi));

  const allNotifications = {
    'Approval of Voucher': transactions,
    'Approval of Cheque Cancellation': cheque,
    'General Journal - AP Approval': journals, // Assuming cheque holds data for General Journal as well
    'General Journal - Confidential - 12': journals,
    'General Journal - Sales Approval': journals,
    'General Journal - FO Approval': journals,
    'General Journal - Live Approval': journals,
    'General Journal - Year End Approval': journals, // new
    'General Journal - Confidential Year End Approval': journals, // new
    'General Journal - PCF Approval': journals, // new
    'General Journal - Cost & Budget Approval - 30': journals, // new
    'General Journal - AP Specialist Approval - 22': journals, // new
    'General Journal - Account Receivable Approval': journals, // New
    'General Journal - AP Specialist Approval - 12': journals, // New
    'General Journal - Accruals & Reversals Approval': journals, // New
  };

  const allLoadingStates = {
    isTransactionsLoading,
    isChequeLoading,
    isJournalsLoading,
  };

  return (
    <Accordion defaultExpanded={/approver/i.test(user.role)} elevation={0} square disableGutters>
      <AccordionSummary
        className={isActiveDropdown ? `FstoSidebarActiveDropdown-root ${color}` : `FstoSidebarDropdown-root ${color}`}
        expandIcon={<ExpandIcon htmlColor="white" />}
      >
        <ApprovalIcon />
        <Typography variant="sidebar">Approval</Typography>
        {approvalItemsConfig.some(
          (item) => user.permissions.includes(item.permission) && shouldDisplayDotNotification(allNotifications[item.notificationKey], item.notificationKey),
        ) ? (
          <BulletActive className="FstoSidebarActiveNotif-root" />
        ) : null}
      </AccordionSummary>

      <AccordionDetails className="FstoSidebarAccordionDetails-root">
        {approvalItemsConfig.map(
          (item) =>
            user.permissions.includes(item.permission) && (
              <RouterLink className="FstoSidebarLink-root" to={item.to} key={item.label}>
                {item.label}
                {!allLoadingStates[item.isLoadingProp] && (
                  <DisplayBubbleNotification notificationArray={allNotifications[item.notificationKey]} permission={item.notificationKey} value="pending" />
                )}
              </RouterLink>
            ),
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default SidebarApprovalDropdown;
